module.exports = __webpack_public_path__ + "static/people_img4@2x-7fab86a7f5728129f914615dc16ba7fc.png";